import EmojiPicker, { Theme } from "emoji-picker-react";
import { EmojiClickData } from "emoji-picker-react";
import { useTheme } from "../contexts/ThemeContext";
import "./EmojiPicker.css";

interface Emoji {
  id: string;
  name: string;
  animated: boolean;
  url: string;
}

interface EmojiPickerProps {
  emojis: Emoji[];
  onSelectEmoji: (emoji: string) => void;
  onClose: () => void;
}

function CustomEmojiPicker({
  emojis,
  onSelectEmoji,
  onClose,
}: EmojiPickerProps) {
  const { isDarkMode } = useTheme();

  const handleEmojiClick = (emojiData: EmojiClickData) => {
    onSelectEmoji(emojiData.emoji);
    onClose();
  };

  const handleCustomEmojiClick = (emoji: Emoji) => {
    // For custom emojis, use the format <:name:id> or <a:name:id> for animated
    const emojiFormat = emoji.animated
      ? `<a:${emoji.name}:${emoji.id}>`
      : `<:${emoji.name}:${emoji.id}>`;
    onSelectEmoji(emojiFormat);
    onClose();
  };

  return (
    <div className="emoji-picker-overlay" onClick={onClose}>
      <div className="emoji-picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="emoji-picker-modal-header">
          <h3>Select Emoji</h3>
          <button className="emoji-picker-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="emoji-picker-content">
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            theme={isDarkMode ? Theme.DARK : Theme.LIGHT}
            autoFocusSearch={true}
            width={450}
            height={500}
            previewConfig={{
              showPreview: false,
            }}
          />
        </div>

        {emojis.length > 0 && (
          <div className="custom-emojis-section">
            <h4>Server Emojis ({emojis.length})</h4>
            <div className="custom-emoji-grid">
              {emojis.map((emoji) => (
                <button
                  key={emoji.id}
                  className="custom-emoji-btn"
                  onClick={() => handleCustomEmojiClick(emoji)}
                  title={`:${emoji.name}:`}
                >
                  <img src={emoji.url} alt={emoji.name} />
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomEmojiPicker;
